/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Gavel56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M48 27c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM12 10a8 8 0 110 16 8 8 0 010-16z"
            />
            <g fillRule="nonzero">
                <path
                    fill={vars.bdlBoxBlue}
                    d="M33.125 21L29 25.126 45.2 42.74l.085.088c1.51 1.51 3.884 1.558 5.422.168l.217-.212.042-.044a3.919 3.919 0 00-.23-5.535L33.125 21zm.27 3L49.39 38.714c.77.707.819 1.905.111 2.675l-.055.056c-.739.74-1.938.74-2.677 0L32 25.395 33.396 24z"
                />
                <path
                    fill={vars.white}
                    d="M33.396 24l15.993 14.714c.77.707.819 1.905.111 2.675l-.055.056c-.739.74-1.938.74-2.677 0L32 25.395 33.396 24z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M35.11 20l.712.711a4.024 4.024 0 010 5.689L34.4 27.822a4.024 4.024 0 01-5.689 0L28 27.11 35.11 20zm-1.101 2L30 26.009c.36.547.74.863 1.14.947a2.013 2.013 0 001.734-.444l.11-.102 1.426-1.426c.5-.5.683-1.2.546-1.845-.091-.43-.407-.81-.947-1.139z"
                />
                <path
                    fill={vars.bdlBoxBlue10}
                    d="M34.009 22L30 26.009c.36.547.74.863 1.14.947a2.013 2.013 0 001.734-.444l.11-.102 1.426-1.426c.5-.5.683-1.2.546-1.845-.091-.43-.407-.81-.947-1.139z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M26.784 10.187l-8.597 8.597a4.05 4.05 0 000 5.73l4.298 4.299a4.052 4.052 0 005.731 0l8.597-8.597a4.05 4.05 0 000-5.73l-4.298-4.299a4.052 4.052 0 00-5.731 0zm1.435 1.408a2.033 2.033 0 012.874 0l4.312 4.312c.793.794.793 2.08 0 2.874l-8.624 8.624a2.033 2.033 0 01-2.874 0l-4.312-4.312a2.033 2.033 0 010-2.874l8.624-8.624z"
                />
                <path
                    fill={vars.white}
                    d="M28.219 11.595a2.033 2.033 0 012.874 0l4.312 4.312c.793.794.793 2.08 0 2.874l-8.624 8.624a2.033 2.033 0 01-2.874 0l-4.312-4.312a2.033 2.033 0 010-2.874l8.624-8.624z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M14.83 22.83a2.83 2.83 0 014.003 0l5.338 5.337a2.832 2.832 0 01-4.004 4.004l-5.337-5.338a2.832 2.832 0 010-4.004zm1.438 1.438a.914.914 0 00-.071 1.213l.07.08 5.172 5.171a.914.914 0 001.364-1.213l-.07-.08-5.172-5.171a.914.914 0 00-1.293 0z"
                />
                <path
                    fill={vars.bdlBoxBlue05}
                    d="M16.268 24.268a.914.914 0 00-.071 1.213l.07.08 5.172 5.171a.914.914 0 001.364-1.213l-.07-.08-5.172-5.171a.914.914 0 00-1.293 0z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M30.83 6.83a2.83 2.83 0 014.003 0l5.338 5.337a2.832 2.832 0 01-4.004 4.004l-5.337-5.338a2.832 2.832 0 010-4.004zm1.438 1.438a.914.914 0 00-.071 1.213l.07.08 5.172 5.171a.914.914 0 001.364-1.213l-.07-.08-5.172-5.171a.914.914 0 00-1.293 0z"
                />
                <path
                    fill={vars.bdlBoxBlue10}
                    d="M32.268 8.268a.914.914 0 00-.071 1.213l.07.08 5.172 5.171a.914.914 0 001.364-1.213l-.07-.08-5.172-5.171a.914.914 0 00-1.293 0z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M28.688 14.688a.5.5 0 01.765.638l-.058.07-6 6a.502.502 0 01-.707 0 .502.502 0 01-.058-.639l.058-.069 6-6z"
                />
            </g>
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M20 40c2.03 0 3.723 1.518 3.973 3.57l.02.207.008.223H25a3 3 0 012.995 2.824L28 47v1h23a1 1 0 010 2H4v-3a3 3 0 012.824-2.995L7 44h1a4 4 0 013.8-3.995L12 40h8zm5 6H7a1 1 0 00-.993.883L6 47v1h20v-1a1 1 0 00-1-1zm-5-4h-8a2.001 2.001 0 00-1.995 1.85L10 44h12l-.005-.15A2.001 2.001 0 0020 42zM6.5 41a.5.5 0 01.09.992L6.5 42h-2a.5.5 0 01-.09-.992L4.5 41h2zm-.716-3.911l.07.057 2 2 .057.07a.501.501 0 01-.057.638.501.501 0 01-.638.057l-.07-.057-2-2-.057-.07a.501.501 0 01.057-.638.501.501 0 01.638-.057zM9.5 36a.5.5 0 01.492.41l.008.09v2a.5.5 0 01-.992.09L9 38.5v-2a.5.5 0 01.5-.5z"
            />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M25 46a1 1 0 011 1v1H6v-1a1 1 0 011-1h18z" />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M20 42c1.054 0 1.918.816 1.995 1.85L22 44H10a2 2 0 012-2h8z"
            />
        </g>
    </AccessibleSVG>
);

export default Gavel56;
